import { ProjectMemberRole } from "@prisma/client";
import { ProjectMemberData } from "@/app/types/project/ProjectMember";

export class UProjectMember {
  public static getRole(
    members: ProjectMemberData[],
    userId?: number | null,
  ): ProjectMemberRole | null {
    if (!userId) {
      return null;
    }
    return members.find((m) => m.userId === userId)?.role ?? null;
  }

  public static canManageMembers(role: ProjectMemberRole | null): boolean {
    return role === ProjectMemberRole.OWNER || role === ProjectMemberRole.ADMIN;
  }
}
